// Set options logic.
let userSelect = document.getElementById('request-type-user');
let topicsSelect = document.getElementById('request-type-topics');

userSelect.onchange = () => {
  topicsSelect.removeAttribute("disabled");
  topicsSelect.value = "";
  topicsSelect.querySelectorAll('option').forEach(function(el) {
    el.style.display = 'none';
  });

  if (userSelect.value === "buyer") {
    topicsSelect.querySelectorAll('.topic-buyer').forEach(function(el) {
      el.style.display = 'block';
    });
  }
  else if (userSelect.value === "artist") {
    topicsSelect.querySelectorAll('.topic-artist').forEach(function(el) {
      el.style.display = 'block';
    });
  }
}

(() => {
  // Set counter logic.
  let textArea = document.getElementById("ContactForm-message");
  let charsCounter = document.getElementById("charsCounter");
  let currentLength =  document.getElementById("currentLength");
  const maxLength = textArea.getAttribute('maxlength');
  document.getElementById("maxLength").innerText = maxLength;

  const countChars = () => {
    let addedChars = textArea.value.length;
    currentLength.textContent = addedChars;

    let method = addedChars === +maxLength ? "add" : "remove";
    charsCounter.classList[method]('danger');
  };

  textArea.addEventListener("input", countChars);
})();
